import { CheckCircle2 } from 'lucide-react';

const STEP_LABELS = ['Options', 'Companies', 'Review', 'Upload'];

// Compact stepper that sits above the order summary so the working area keeps its full width.
const WizardProgressBar = ({ currentStep }) => (
  <ol className="flex items-start mb-4" aria-label="Order steps">
    {STEP_LABELS.map((label, index) => {
      const step = index + 1;
      const isDone = step < currentStep;
      const isCurrent = step === currentStep;
      return (
        <li key={label} className={`flex items-start ${step < STEP_LABELS.length ? 'flex-1' : ''}`} aria-current={isCurrent ? 'step' : undefined}>
          <div className="flex flex-col items-center">
            <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold font-heading ${
              isDone || isCurrent ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
            }`}>
              {isDone ? <CheckCircle2 className="w-4 h-4" /> : step}
            </span>
            <span className={`text-[11px] mt-1 font-medium ${step <= currentStep ? 'text-foreground' : 'text-muted-foreground'}`}>
              {label}
            </span>
          </div>
          {step < STEP_LABELS.length && (
            <span className={`flex-1 h-0.5 mx-1.5 mt-3.5 ${isDone ? 'bg-primary' : 'bg-border'}`} />
          )}
        </li>
      );
    })}
  </ol>
);

export default WizardProgressBar;
